module.exports = __webpack_public_path__ + "img/adorno.137bd731.svg";